module.exports = __webpack_public_path__ + "static/media/Gas cylinder.97e2383e.png";